import { makeStyles } from '@material-ui/core/styles';

export default makeStyles({
  label: {
    marginBottom: 16
  }
});
